import { delay } from 'redux-saga/effects';
import { call, fork, put, select, take, takeLatest } from 'redux-saga/effects';
import { getDate, getLayout, getCameraFromCell } from 'selectors/monitoringSelectors';
import { getTimelineMessages } from 'selectors/timelineSelectors';
import { timelineSuccess, timelinesRedraw, TimelinesRedrawAction } from 'actions/timelineActions';
import { Camera, CameraMessage, CellIndex, Timeline } from 'types';
import { generateTimelineSaga } from './generateTimelineSaga';


export function* setLayoutWatcher() {
    while (true) {
        yield take('SET_LAYOUT');

        // HACK: give the set layout action 100ms to take effect first because we need to
        //       query the updated UI to get the display width so we know how wide to make
        //       the timelines.
        yield delay(100);

        yield put(timelinesRedraw());
    }
}

export function* timelinesRedrawWatcher() {
    yield takeLatest('TIMELINES_REDRAW', redrawTimelinesSaga);
}

export function* redrawTimelinesSaga(action: TimelinesRedrawAction) {
    const utcDate = yield select(getDate);
    const nCells = yield select(getLayout);
    for (let cellIndex = 0 as CellIndex; cellIndex < nCells + 1; cellIndex++) {
        yield fork(redrawTimelineSaga, cellIndex, utcDate);
    }
}

export function* redrawTimelineSaga(cellIndex: CellIndex, utcDate: Date) {
    const camera: Camera = yield select(getCameraFromCell, { cellIndex });
    if (!camera) {
        return;
    }

    // Get the cached messages for this camera
    const messages: CameraMessage[] = yield select(getTimelineMessages, camera);

    let timeline: Timeline;
    try {
        timeline = yield call(generateTimelineSaga, cellIndex, utcDate, messages);
    }
    catch (err) {
        return;
    }

    yield put(timelineSuccess(timeline, { cellIndex, utcDate }));
}



// WEBPACK FOOTER //
// ./src/sagas/monitoring/timelinesRedrawSaga.ts